import { type Action, configureStore, type ThunkAction } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import { userApi } from './user/user'
import { idpApi } from './idp/idp'
import { academyAuthApi } from './academy/academy'
import { docsAuthApi } from './docs/docs'

export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(userApi.middleware, idpApi.middleware, academyAuthApi.middleware, docsAuthApi.middleware),
  reducer: {
    auth: authReducer,
    [userApi.reducerPath]: userApi.reducer,
    [idpApi.reducerPath]: idpApi.reducer,
    [academyAuthApi.reducerPath]: academyAuthApi.reducer,
    [docsAuthApi.reducerPath]: docsAuthApi.reducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
